var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1712_57053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V19H29V0H0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L29 19L0 0ZM29 0L0 19L29 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 0L0 19M0 0L29 19L0 0Z",
    stroke: "white",
    strokeWidth: 3.86667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L29 19L0 0ZM29 0L0 19L29 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 0L0 19M0 0L29 19L0 0Z",
    stroke: "#C8102E",
    strokeWidth: 2.57778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0V19V0ZM0 9.5H29H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5H29M14.5 0V19V0Z",
    stroke: "white",
    strokeWidth: 6.44444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0V19V0ZM0 9.5H29H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5H29M14.5 0V19V0Z",
    stroke: "#C8102E",
    strokeWidth: 3.86667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1712_57053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag_en.c95d7019aeeea32068581757eab80e25.svg";
export { ForwardRef as ReactComponent };